import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {apiAction} from "../../helpers/HTTP";
import {LOADING_PAGE} from "../../constants/constants";

const initialState = {
    loadingType: null,
    error: null,
    box: null,
    usersBoxes: null,
    membershipUser: null,
    language: null,
    selectedLocation: null,
    token: null,
    linkError: null
}

export const kioskSlice = createSlice({
    name: 'kiosk',
    initialState: initialState,
    reducers: {
        setKioskToken: (state, action) => {
            state.token = action.payload
        },
        setLinkError: (state, action) => {
            state.linkError = action.payload
        },
        setKioskLang: (state, action) => {
            state.language = action.payload
        },
        setKioskLoadingType: (state, action) => {
            state.loadingType = action.payload
        },

        setKioskError: (state, action) => {
            state.error = action.payload
        },
    },
    extraReducers: builder => {
        builder.addCase(validateKioskToken.pending, (state,action) => {
            state.loadingType = LOADING_PAGE
        })
        builder.addCase(validateKioskToken.fulfilled, (state, action) => {
            state.loadingType = null
            state.linkError = null
            state.box = action.payload.usersBoxes.box
            state.usersBoxes = action.payload.usersBoxes
            state.membershipUser = action.payload.membershipUser ?? null
            state.selectedLocation = action.payload.location
        })
        builder.addCase(validateKioskToken.rejected, (state, action) => {
            state.loadingType = null
            state.box = null
            state.usersBoxes = null
            state.membershipUser = null
            state.selectedLocation = null
            state.linkError = action.payload?.error?.messageToUser ?? 'defaultLinkError'
        })
    }
})

export const { setKioskToken, setLinkError, setKioskLang, setKioskLoadingType, setKioskError } = kioskSlice.actions
export default kioskSlice.reducer

export const validateKioskToken = createAsyncThunk('validateKioskToken', async (params, {dispatch, rejectWithValue}) => {
    try {
        return await apiAction('validateKioskToken', 'get');
    } catch (e) {
        return rejectWithValue(e);
    }
})